import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {ConfirmationModalWindow} from '../confirmation-modal-window/ConfirmationModalWindow';
import {FormattedDate, useIntl} from 'react-intl';

import './styles.scss';
import {ButtonVariant, GritxButton} from '@wholesalechange/chatcomponent';
import {
  editTrainingDialogue,
  removeTrainingDialogue,
  trainingsAsyncActions
} from '../../redux/pageAsyncActions';
import {ITrainingDialogue} from '../../redux/trainings/interfaces';
import TrainingModalWindow from '../training-modal-window';

type Props = {
  card: ITrainingDialogue;
  onClick: () => void;
};

export const TrainingCard = ({
  card,
  onClick
}: Props): JSX.Element => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [cardData, setCardData] = useState<ITrainingDialogue>(card);
  const [isShowEditDialogue, setShowEditDialogue] = useState<boolean>(false);
  const [isShowDeleteDialogue, setShowDeleteDialogue] = useState<boolean>(false);

  function handleOpenEditDialogueModal() {
    setShowEditDialogue(true);
  }

  useEffect(() => {
    setCardData(card);
  }, [card]);

  function handleEditDialogue(dialogue: ITrainingDialogue) {
    dispatch(trainingsAsyncActions[editTrainingDialogue](dialogue));
    setCardData(dialogue);
    setShowEditDialogue(false);
  }

  function handleDeleteDialogue() {
    dispatch(trainingsAsyncActions[removeTrainingDialogue](cardData));
  }

  function handleCloseDialogue() {
    setShowEditDialogue(false);
  }

  function handleOpenDeleteDialogue() {
    setShowDeleteDialogue(true);
  }

  function handleCloseDeleteDialogue() {
    setShowDeleteDialogue(false);
  }

  function handleClick() {
    onClick();
  }

  function renderBasicCard() {
    return <div className="training-area">
      <div className="training-area__card-place">
        <div className="training-area__card">
          <div className="training-area__title">
            <div className="training-area__title-wrapper">
              <button className="training-area__title__text" onClick={handleClick}>{cardData.dialogName}</button>
              <div className="training-area__title__date">{cardData.dialogUserDate != null
                && <FormattedDate
                  value={cardData.dialogUserDate}
                  year="numeric"
                  month="long"
                  hour="numeric"
                  minute="numeric"
                  day="2-digit"
                />}
              </div>
            </div>
          </div>
          <div className="training-area__title-percent" style={{
            background: `linear-gradient(to left, #f2f2f2 ${100 - cardData.percentage}%, #EBA378 ${100 - cardData.percentage}%)`
          }} />
        </div>
        <div className="training-area__bottom">
          <div className="training-area__btn">
            <GritxButton
              title={intl.formatMessage({
                id: 'gritx.trainings.card.rename',
                defaultMessage: 'Rename'
              })}
              variant={ButtonVariant.Outline}
              disabled={false}
              className="training-area__button"
              onClick={handleOpenEditDialogueModal}
            />
          </div>
          <div className="training-area__btn">
            <GritxButton
              title={intl.formatMessage({
                id: 'gritx.trainings.card.delete',
                defaultMessage: 'Delete'
              })}
              variant={ButtonVariant.Outline}
              disabled={cardData.percentage === 100}
              className="training-area__button"
              onClick={handleOpenDeleteDialogue}
            />
          </div>
        </div>
      </div>

      <TrainingModalWindow
        dialogueCard={card}
        title={intl.formatMessage({
          id: 'gritx.trainings.card.title.edit',
          defaultMessage: 'Edit the training'
        })}
        onSave={handleEditDialogue}
        onClose={handleCloseDialogue}
        show={isShowEditDialogue}
      />

      <ConfirmationModalWindow
        title={intl.formatMessage({
          id: 'gritx.trainings.card.delete.confirmation',
          defaultMessage: 'Are you sure you want to delete the training?'
        })}
        onSave={handleDeleteDialogue}
        onClose={handleCloseDeleteDialogue}
        show={isShowDeleteDialogue}
      />
    </div>;
  }

  return renderBasicCard();
};
